import React from 'react';
import PropTypes from 'prop-types';

import { FormattedDate, FormattedMessage } from 'react-intl';

import moment from 'utils/moment';
import { getShiftTypeByDate, calculateDuration, renderInfoForType } from '../../../../utils/helpers';

import styles from '../../inspections.module.scss';
import { DROPDOWN_BASED_SHIFT } from '../../../../constants/ModelStatus';

const DataSummary = ({ inspection, answer, shiftTypes, shiftSetting, url }) => {
  const shift = shiftSetting === DROPDOWN_BASED_SHIFT
    ? answer?.shift_name : getShiftTypeByDate(moment(inspection.inspection_date).format('YYYY-MM-DDTHH:mm:ssz'), shiftTypes)
    ?.name;
  const duration = calculateDuration(inspection?.start_date, inspection?.inspection_date);
  let titles = {
    inspection_date: { id: 'inspection.inspection_date', default: 'INSPECTION-DATE' }
  };
  if (url?.includes('sms')) {
    titles = {
      inspection_date: { id: 'safetyAudits.audit_date', default: 'AUDIT END DATE' }
    };
  }
  return (
    <div className={styles.datasources}>
      <div className={styles.column}>
        <h5>
          {inspection?.inspected_by?.fullname}
        </h5>
        <p className={styles.email}>
          {inspection?.inspected_by?.email}
        </p>
      </div>
      <div className={styles.column}>
        <h5>
          <FormattedDate
            value={inspection?.inspection_date}
            month="short"
            day="numeric"
            year="numeric"
          />
        </h5>
        <p>
          <FormattedMessage id={titles.inspection_date.id} defaultMessage={titles.inspection_date.default} />
        </p>
      </div>
      <div className={styles.column}>
        {inspection.start_date
          ?(
            <h5>
              {inspection && renderInfoForType({ type: 'time' }, inspection?.start_date, null, null)}
            </h5>
          )
          :<p>-</p>}
        <p><FormattedMessage id="inspection.start_time" defaultMessage="START-TIME" /></p>
      </div>
      <div className={styles.column}>
        <h5>
          {inspection && renderInfoForType({ type: 'time' }, inspection?.inspection_date, null, null)}
        </h5>
        <p><FormattedMessage id="inspection.end_time" defaultMessage="END-TIME" /></p>
      </div>
      <div className={styles.column}>
        <h5>
          {`${duration!=='-'?`${duration}  minutes`:duration}`}
        </h5>
        <p><FormattedMessage id="inspection.duration" defaultMessage="Duration" /></p>
      </div>
      <div className={styles.column}>
        <h2>{shift}</h2>
        <p><FormattedMessage id="inspection.inspection_shift" defaultMessage="Shift" /></p>
      </div>
      <div className={styles.column}>
        <h2 className={styles.danger}>
          {inspection?.issues}
        </h2>
        <p><FormattedMessage id="inspection.total_issues" defaultMessage="UNSATISFACTORY" /></p>
      </div>
      {answer?.new_issues !== null && (
        <>
          <div className={styles.column}>
            <h2 className={styles.danger}>
              {answer?.workorders_count}
            </h2>
            <p><FormattedMessage id="inspection.total_isses" defaultMessage="TOTAL WORK ORDERS" /></p>
          </div>
          <div className={styles.column}>
            <h2 className={styles.danger}>
              {answer?.new_issues}
            </h2>
            <p><FormattedMessage id="inspection.new_isses" defaultMessage="NEW WORK ORDERS" /></p>
          </div>
        </>
      )}
    </div>
  );
};

DataSummary.propTypes = {
  inspection: PropTypes.shape({}).isRequired,
  answer: PropTypes.shape({}).isRequired,
  fields: PropTypes.shape({}).isRequired
};
export default DataSummary;
